import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shared-page" }
const _hoisted_2 = { class: "centeredContentBox" }
const _hoisted_3 = {
  id: "welcomeText",
  class: "bottomSpaceDouble"
}
const _hoisted_4 = {
  key: 0,
  class: "alertBox bottomSpace"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: true }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          id: "logoWrap",
          class: "bottomSpaceDouble"
        }, [
          _createTextVNode("ZB"),
          _createElementVNode("span", { id: "logoEdgeWrap" }, [
            _createElementVNode("span", { id: "logoEWrap" }, "E"),
            _createTextVNode("dge")
          ]),
          _createTextVNode(" ")
        ], -1)),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('welcome_text')), 1),
        (_ctx.errorDisplayKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.errorDisplayKey)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}